export enum FormTypes {
  CONSULTATION_FEEDBACK = "consultation_feedback"
}
